import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TalentTrackProfilesComponent } from './modules/talent-track/talent-track-profiles/talent-track-profiles.component';
import { AuthPageComponent } from '@app/modules/auth/components/auth-page/auth-page.component';
import { AuthGuard } from '@app/core/guards/auth.guard';
import { AuthCallbackComponent } from './core/auth-callback/auth-callback.component';
import { FormsComponent } from './modules/form-generator/forms/forms.component';
import { CreateFormComponent } from './modules/form-generator/create-form/create-form.component';
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import { ReportsComponent } from './modules/reports/reports.component';
import { HeadcountReportComponent } from './modules/reports/components/headcount-report/headcount-report.component';
import { PacketComponent } from './modules/packets/components/packet/packet.component';
import {
    SettingsOnboardingTaskChecklistComponent
} from './modules/talent-track/talent-track-edit-employee/edit-employee/components/employee-details/components/onboarding-demo/settings-onboarding-task-checklist/settings-onboarding-task-checklist.component';
import { LookupComponent } from './modules/lookup/lookup.component';
import { PositionsComponent } from './modules/positions/positions.component';
import { EmployementRecordsV2Component } from './modules/talent-track/talent-track-edit-employee/edit-employee/components/employment-records/components/employement-records-v2/employement-records-v2.component';
import { EmploymentRecordDetailsComponent } from './modules/talent-track/talent-track-edit-employee/edit-employee/components/employment-records/components/employment-record-details/employment-record-details.component';
import { SecurityMenuComponent } from './modules/security-menu/security-menu.component';
import { OrgChartComponent } from './modules/org-chart/org-chart.component';
import { HeadcountByMonthReportComponent } from './modules/reports/components/headcount-by-month-report/headcount-by-month-report.component';
import { WorkforcePlanningReportComponent } from './modules/reports/components/workforce-planning-report/workforce-planning-report.component';
import { DiversityBenchmarkReportComponent } from './modules/reports/components/diversity-benchmark-report/diversity-benchmark-report.component';
import { WorkRotationsComponent } from './modules/work-rotations/work-rotations.component';
import { CreatedLettersListComponent } from './modules/letter-generator/components/created-letters-list/created-letters-list.component';
import { CreateLetterComponent } from './modules/letter-generator/components/create-letter/create-letter.component';
import { SendLetterComponent } from './modules/letter-generator/components/send-letter/send-letter.component';
import { CompensationReportComponent } from '@app/modules/reports/components/compensation-report/compensation-report.component';
import { TimeOffMenuComponent } from '@app/modules/time-off/time-off-menu.component';
import { MonthlyAbsenceReportComponent } from './modules/reports/components/monthly-absence-report/monthly-absence-report.component';
import { MonthlyHolidayUtilisationReportComponent } from './modules/reports/components/monthly-holiday-utilisation-report/monthly-holiday-utilisation-report.component';
import { NewsFeedComponent } from './modules/news-feed/news-feed.component';
import { InboxComponent } from './modules/inbox/inbox.component';
import { HomepageComponent } from './modules/homepage/homepage.component';
import { ReportsRectangleDisplayListComponent } from './modules/reports/components/reports-rectangle-display-list/reports-rectangle-display-list.component';
import { CompensationSectionDemoComponent } from './modules/talent-track/talent-track-edit-employee/edit-employee/components/compensation-section-demo/compensation-section-demo.component';
import { SiteSettingsConfigureComponent } from '@app/modules/site-settings-configure/site-settings-configure.component';
import { TranslationsComponent } from './modules/translations/translations.component';
import { CostCentersComponent } from '@app/modules/cost-centers/cost-centers.component';
import { WorkRotationEditorComponent } from '@app/modules/work-rotations/components/work-rotation-editor/work-rotation-editor.component';
import { BenefitsComponent } from './modules/benefits/benefits.component';
import { BenefitsCoveragesComponent } from './modules/benefits/components/benefits-coverages/benefits-coverages.component';
import { BenefitsPlanTypesComponent } from './modules/benefits/components/benefits-plan-types/benefits-plan-types.component';
import { BenefitsPlanTypeDetailsComponent } from './modules/benefits/components/benefits-plan-types/components/benefits-plan-type-details/benefits-plan-type-details.component';
import { SiteSettingsMenuComponent } from './modules/site-settings-menu/site-settings-menu.component';
import { BenefitsPlansComponent } from './modules/benefits/components/benefits-plans/benefits-plans.component';
import { BenefitsPlanEditorComponent } from './modules/benefits/components/benefits-plans/components/benefits-plan-editor/benefits-plan-editor.component';
import { BenefitsGroupsComponent } from './modules/benefits/components/benefits-groups/benefits-groups.component';
import { BenefitGroupEditorComponent } from './modules/benefits/components/benefits-groups/components/benefit-group-editor/benefit-group-editor.component';
import { SecurityRoleEditorComponent } from '@app/modules/security-roles/components/security-role-editor/security-role-editor.component';
import { IntegrationConfigurationComponent } from '@app/modules/integration-configuration/integration-configuration.component';
import { SecurityRolesComponent } from '@app/modules/security-roles/security-roles.component';
import { ApiSetupComponent } from '@app/modules/api-setup/api-setup.component';
import { SecuritySetupComponent } from '@app/modules/security-setup/security-setup.component';
import { EditFormV3Component } from './modules/form-generator/edit-form-v3/edit-form-v3.component';
import { StatutoryHolidaysComponent } from '@app/modules/statutory-holidays/statutory-holidays.component';
import { HolidayGroupsEditorComponent } from '@app/modules/statutory-holidays/components/holiday-groups-editor/holiday-groups-editor.component';
import { OrganizationStructureComponent } from '@app/modules/organization-structure/organization-structure.component';
import { OrganizationEditorComponent } from '@app/modules/organization-structure/components/organization-editor/organization-editor.component';
import { EmployeeSecurityComponent } from './modules/talent-track/talent-track-edit-employee/edit-employee/components/employee-security/employee-security.component';
import { CountryConfigurationComponent } from './modules/country-configuration/country-configuration.component';
import { EmployeeBankDetailsReportComponent } from './modules/reports/components/employee-bank-details-report/employee-bank-details-report.component';
import { BasicEmployeeReportComponent } from './modules/reports/components/basic-employee-report/basic-employee-report.component';
import { BasicHeadcountReportComponent } from './modules/reports/components/basic-headcount-report/basic-headcount-report.component';
import { TableFieldEditorComponent } from './modules/table-field-editor/table-field-editor.component';
import { AdminControlsComponent } from './modules/admin-controls/admin-controls.component';
import { AddDummyPositionsComponent } from './modules/admin-controls/components/add-dummy-positions/add-dummy-positions.component';
import { AddDummyOrganizationsComponent } from './modules/admin-controls/components/add-dummy-organizations/add-dummy-organizations.component';
import { AddDummyEmployeesComponent } from './modules/admin-controls/components/add-dummy-employees/add-dummy-employees.component';
import { AssignPositionsToAllComponent } from './modules/admin-controls/components/assign-positions-to-all/assign-positions-to-all.component';
import { RunJobFormComponent } from './modules/generate-schedules/components/run-job-form/run-job-form.component';
import { PositionEditorPageComponent } from './modules/positions/components/position-editor-page/position-editor-page.component';
import { CanDeactivateGuard } from './core/guards/can-deactivate.guard';
import { api_routes, routes } from './consts';
import {
    EmploymentRecordPositionsComponent
} from './modules/talent-track/talent-track-edit-employee/edit-employee/components/employment-records/components/employment-record-details/components/employment-record-positions/employment-record-positions.component';
import { ReportRendererComponent } from '@app/modules/custom-reports/components/report-renderer/report-renderer.component';
import { ReportsListComponent } from '@app/modules/custom-reports/components/reports-list/reports-list.component';
import { ReportBuilderComponent } from '@app/modules/custom-reports/components/report-builder/report-builder.component';
import { WorkLocationsListComponent } from './modules/work-locations/components/work-locations-list/work-locations-list.component';
import { PerformanceComponent } from './modules/performance/performance.component';
import { GoalTypesComponent } from './modules/performance/components/goal-types/goal-types.component';
import { GoalPlansComponent } from './modules/performance/components/goal-plans/goal-plans.component';
import { GoalPlanEditorComponent } from './modules/performance/components/goal-plans/components/goal-plan-editor/goal-plan-editor.component';
import { AllGoalsListComponent } from './modules/performance/components/all-goals-list/all-goals-list.component';
import { AbsenceReportComponent } from '@app/modules/reports/components/absence-report/absence-report.component';
import { AbsenceFinanceReportComponent } from '@app/modules/reports/components/absence-finance-report/absence-finance-report.component';
import { OutstandingAbsenceReportComponent } from '@app/modules/reports/components/outstanding-absence-report/outstanding-absence-report.component';
import { PendingTimeOffReportComponent } from '@app/modules/reports/components/pending-time-off-report/pending-time-off-report.component';
import { ToilPoliciesTypesComponent } from './modules/time-off-in-lieu/toil-policies-types/toil-policies-types.component';
import { ToilEmailsComponent } from './modules/time-off-in-lieu/toil-emails/toil-emails.component';
import { EmployeeLoginReportComponent } from './modules/reports/components/employee-login-report/employee-login-report.component';
import { TimeOffPoliciesTypesComponent } from './modules/time-off/time-off-policies-types/time-off-policies-types.component';
import { TimeOffEmailsComponent } from './modules/time-off/time-off-emails/time-off-emails.component';
import { AddDummyWorkRotationsComponent } from './modules/admin-controls/components/add-dummy-work-rotations/add-dummy-work-rotations.component';
import { AddDummyWorkLocationsComponent } from './modules/admin-controls/components/add-dummy-work-locations/add-dummy-work-locations.component';
import { AddDummyCostCentersComponent } from './modules/admin-controls/components/add-dummy-cost-centers/add-dummy-cost-centers.component';
import { SplashPageComponent } from './core/splash-page/splash-page.component';
import { UnsavedGuard } from './core/guards/unsaved.guard';
import { ReviewPlansComponent } from './modules/performance/components/review-plans/review-plans.component';
import { ReviewPlanEditorComponent } from './modules/performance/components/review-plans/components/review-plan-editor/review-plan-editor.component';
import { ReviewRatingsComponent } from './modules/performance/components/review-ratings/review-ratings.component';
import { ReviewsComponent } from './modules/performance/components/reviews/reviews.component';
import { ReviewPageComponent } from './modules/performance/components/review-page/review-page.component';
import { BusinessRuleAutomationComponent } from "@app/modules/business-rule-automation/business-rule-automation.component";
import { BusinessRuleAutomationFormComponent } from "@app/modules/business-rule-automation/components/business-rule-automation-form/business-rule-automation-form.component";
import { EmployeeGoalsPageComponent } from './modules/performance/components/employee-goals-page/employee-goals-page.component';
import { ModuleConfigurationComponent } from './modules/admin-controls/components/module-configuration/module-configuration.component';
import { GoalsReportComponent } from "@app/modules/reports/components/performance-goals-report/goals-report.component";
import { StylingColoursComponent } from './modules/site-settings-styling/components/styling-colours/styling-colours.component';
import { StylingColourEditorComponent } from './modules/site-settings-styling/components/styling-colours/components/styling-colour-editor/styling-colour-editor.component';
import { SiteSettingsStylingComponent } from './modules/site-settings-styling/site-settings-styling.component';
import { CompanyLogosComponent } from './modules/site-settings-styling/components/company-logos/company-logos.component';
import { CompanyLogoEditorComponent } from './modules/site-settings-styling/components/company-logos/components/company-logo-editor/company-logo-editor.component';
import { CreateCompanyLogoComponent } from './modules/site-settings-styling/components/company-logos/components/create-company-logo/create-company-logo.component';
import { EditCompanyLogoFileComponent } from './modules/site-settings-styling/components/company-logos/components/edit-company-logo-file/edit-company-logo-file.component';
import { CultureConfigurationComponent } from './modules/admin-controls/components/culture-configuration/culture-configuration.component';
import { PerformanceSectionMyReviewsComponent } from './modules/performance/components/reviews/components/performance-section-my-reviews/performance-section-my-reviews.component';
import { GlobalReviewsComponent } from './modules/performance/components/global-reviews/global-reviews.component';
import { GlobalReviewComponent } from './modules/performance/components/global-reviews/components/global-review/global-review.component';
import { LettersComponent } from './modules/letters/letters.component';
import { LetterTemplateEditorComponent } from './modules/letters/components/letter-templates/components/letter-template-editor/letter-template-editor.component';
import { ReviewStatusReportComponent } from './modules/reports/components/performance-review-status/review-status-report.component';
import { ToilBalanceReportComponent } from '@app/modules/reports/components/toil-balance-report/toil-balance-report.component';
import { ToilOccurrenceReportComponent } from '@app/modules/reports/components/toil-occurrence-report/toil-occurrence-report.component';
import { IntegrationsComponent } from "@app/modules/site-settings-integrations/integrations.component";
import { IntegrationEditorComponent } from "@app/modules/site-settings-integrations/components/integration-editor/integration-editor.component";
import { LetterGenerationEditorComponent } from './modules/letters/components/letter-generations/components/letter-generation-editor/letter-generation-editor.component';
import { LettersUserSectionComponent } from './modules/letters/components/letters-user-section/letters-user-section.component';
import { LettersAdminSectionComponent } from './modules/letters/components/letters-admin-section/letters-admin-section.component';
import { EmployeeDisciplinesComponent } from './modules/talent-track/talent-track-edit-employee/edit-employee/components/employee-details/components/employee-disciplines/employee-disciplines.component';
import { SiteSettingsPageComponent } from './modules/site-settings-page/site-settings-page.component';
import { TimeoffCalculationEntriesReportComponent } from './modules/reports/components/timeoff-calculation-entries-report/timeoff-calculation-entries-report.component';
import { EmployeeBackgroundChecksComponent } from './modules/talent-track/talent-track-edit-employee/edit-employee/components/employee-details/components/employee-background-checks/employee-background-checks.component';
import { BuySellPlansComponent } from './modules/time-off/buy-sell-plans/buy-sell-plans.component';
import { BuySellPlanEditorComponent } from './modules/time-off/buy-sell-plans/components/buy-sell-plan-editor/buy-sell-plan-editor.component';
import { BuySellApprovalsComponent } from './modules/time-off/buy-sell-approvals/buy-sell-approvals.component';
import { EmployeeTimeOffComponent } from './modules/talent-track/talent-track-edit-employee/edit-employee/components/employee-time-off/employee-time-off.component';
import { EmployeeBuySellRequestComponent } from './modules/talent-track/talent-track-edit-employee/edit-employee/components/employee-time-off/components/employee-buy-sell-request/employee-buy-sell-request.component';
import { TimeoffBuySellHoursReportComponent } from './modules/reports/components/timeoff-buy-sell-hours-report/timeoff-buy-sell-hours-report.component';
import { TimeoffBuySellStatusReportComponent } from './modules/reports/components/timeoff-buy-sell-status-report/timeoff-buy-sell-status-report.component';
import { TimeOffSectionComponent } from './modules/time-off-section/time-off-section.component';
import { BuySellMenuComponent } from './modules/buy-sell-menu/buy-sell-menu.component';
import { EmployeeLayoutComponent } from './modules/talent-track/talent-track-edit-employee/edit-employee/container/employee-layout/employee-layout.component';
import { ArticlesComponent } from './modules/articles/articles.component';
import { ArticlesEditorComponent } from './modules/articles/components/articles-editor/articles-editor.component';
import { ImportsComponent } from './modules/imports/imports.component';
import { ImportEditorComponent } from './modules/imports/components/import-editor/import-editor.component';
import { DocumentsManagerComponent } from './modules/documents/components/documents-manager/documents-manager.component';
import { QuickLinksComponent } from './modules/quick-links/quick-links.component';
import { CurrenciesComponent } from './modules/currencies/currencies.component';

const route_declarations: Routes = [
    {
        path: '',
        canActivate: [AuthGuard],
        component: TalentTrackProfilesComponent
    },
    {
        path: 'auth-callback',
        component: AuthCallbackComponent
    },
    {
        path: 'SplashPage',
        component: SplashPageComponent
    },
    {
        path: 'login',
        canActivate: [AuthGuard],
        component: AuthPageComponent
    },
    {
        path: 'TalentTrack',
        canActivate: [AuthGuard],
        component: TalentTrackProfilesComponent
    },
    {
        path: 'TalentTrack/Edit/:id',
        canActivate: [AuthGuard],
        component: EmployeeLayoutComponent
    },
    {
        path: 'TalentTrack/Edit/:id/:section',
        canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard],
        component: EmployeeLayoutComponent,
    },
    {
        path: 'TalentTrack/Edit/:id/:section/:subSection',
        canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard],
        component: EmployeeLayoutComponent,
    },
    {
        path: 'Form/List',
        canActivate: [AuthGuard],
        component: FormsComponent
    },
    {
        path: 'Form/Create',
        canActivate: [AuthGuard],
        component: CreateFormComponent
    },
    {
        path: 'Form/Edit/:id',
        canActivate: [AuthGuard],
        component: EditFormV3Component
    },
    {
        path: 'Dashboard',
        canActivate: [AuthGuard],
        component: DashboardComponent
    },
    {
        path: 'ReportsList',
        canActivate: [AuthGuard],
        component: ReportsComponent
    },
    {
        path: 'Reports',
        canActivate: [AuthGuard],
        component: ReportsRectangleDisplayListComponent
    },
    {
        path: 'Reports/HeadCountReport',
        canActivate: [AuthGuard],
        component: HeadcountReportComponent
    },
    {
        path: 'Reports/OrgChart',
        canActivate: [AuthGuard],
        component: OrgChartComponent
    },
    {
        path: 'Reports/OrgChart/:type/:isEditable',
        canActivate: [AuthGuard],
        component: OrgChartComponent
    },
    {
        path: 'Reports/HeadcountByMonthReport',
        canActivate: [AuthGuard],
        component: HeadcountByMonthReportComponent
    },
    {
        path: 'Reports/WorkforcePlanningReport',
        canActivate: [AuthGuard],
        component: WorkforcePlanningReportComponent
    },
    {
        path: 'Reports/DiversityBenchmarkReport',
        canActivate: [AuthGuard],
        component: DiversityBenchmarkReportComponent
    },
    {
        path: 'Reports/CompensationReport',
        canActivate: [AuthGuard],
        component: CompensationReportComponent
    },
    {
        path: 'Reports/MonthlyAbsenceReport',
        canActivate: [AuthGuard],
        component: MonthlyAbsenceReportComponent
    },
    {
        path: 'Reports/MonthlyHolidayUtilisationReport',
        canActivate: [AuthGuard],
        component: MonthlyHolidayUtilisationReportComponent
    },
    {
        path: 'Reports/Predefined/ReportEmployeeBankDetails',
        canActivate: [AuthGuard],
        component: EmployeeBankDetailsReportComponent
    },
    {
        path: 'Reports/Predefined/ReportHeadCountReport',
        canActivate: [AuthGuard],
        component: BasicHeadcountReportComponent
    },
    {
        path: 'Reports/Predefined/ReportBasicEmployeeReport',
        canActivate: [AuthGuard],
        component: BasicEmployeeReportComponent
    },
    {
        path: 'Reports/Predefined/ReportToilBalanceReport',
        canActivate: [AuthGuard],
        component: ToilBalanceReportComponent
    },
    {
        path: 'Reports/Predefined/ReportToilOccuranceReport',
        canActivate: [AuthGuard],
        component: ToilOccurrenceReportComponent
    },
    {
        path: 'Reports/Predefined/ReportTimeoffCalculationEntriesReport',
        canActivate: [AuthGuard],
        component: TimeoffCalculationEntriesReportComponent
    },
    {
        path: 'Reports/Predefined/ReportTimeoffCalculationEntriesReport/:employeeId',
        canActivate: [AuthGuard],
        component: TimeoffCalculationEntriesReportComponent
    },
    {
        path: 'Reports/Predefined/ReportTimeoffCalculationEntriesReport/:employeeId/:timeoffTypeId',
        canActivate: [AuthGuard],
        component: TimeoffCalculationEntriesReportComponent
    },
    {
        path: 'Reports/Predefined/ReportTimeOffBuySellHoursReport',
        canActivate: [AuthGuard],
        component: TimeoffBuySellHoursReportComponent
    },
    {
        path: 'Reports/Predefined/ReportTimeOffBuySellStatusReport',
        canActivate: [AuthGuard],
        component: TimeoffBuySellStatusReportComponent
    },
    {
        path: 'Reports/Predefined/ReportEmployeeLoginReport',
        canActivate: [AuthGuard],
        component: EmployeeLoginReportComponent
    },
    {
        path: 'Packet/:id',
        canActivate: [AuthGuard],
        component: PacketComponent
    },
    {
        path: 'Checklist/Settings/:id',
        canActivate: [AuthGuard],
        component: SettingsOnboardingTaskChecklistComponent
    },
    {
        path: 'AdminControls',
        canActivate: [AuthGuard],
        component: AdminControlsComponent
    },
    {
        path: 'AdminControls/ModuleConfiguration',
        canActivate: [AuthGuard],
        component: ModuleConfigurationComponent
    },
    {
        path: `AdminControls${routes.CULTURE_CONFIGURATION}`,
        canActivate: [AuthGuard],
        component: CultureConfigurationComponent
    },
    {
        path: 'AdminControls/Positions',
        canActivate: [AuthGuard],
        component: AddDummyPositionsComponent
    },
    {
        path: 'AdminControls/TalentTrack',
        canActivate: [AuthGuard],
        component: AddDummyEmployeesComponent
    },
    {
        path: 'AdminControls/AssignPositions',
        canActivate: [AuthGuard],
        component: AssignPositionsToAllComponent
    },
    {
        path: 'AdminControls/Organization',
        canActivate: [AuthGuard],
        component: AddDummyOrganizationsComponent
    },
    {
        path: 'AdminControls/WorkRotations',
        canActivate: [AuthGuard],
        component: AddDummyWorkRotationsComponent
    },
    {
        path: 'AdminControls/WorkLocations',
        canActivate: [AuthGuard],
        component: AddDummyWorkLocationsComponent
    },
    {
        path: 'AdminControls/CostCenters',
        canActivate: [AuthGuard],
        component: AddDummyCostCentersComponent
    },
    {
        path: 'TimeOff',
        canActivate: [AuthGuard],
        component: TimeOffSectionComponent
    },
    {
        path: 'TimeOff/TimeOff',
        canActivate: [AuthGuard],
        component: TimeOffMenuComponent
    },
    {
        path: 'SiteSettings',
        canActivate: [AuthGuard],
        component: SiteSettingsPageComponent
    },
    {
        path: 'SiteSettings/Lists',
        canActivate: [AuthGuard],
        component: LookupComponent
    },
    {
        path: 'SiteSettings/Positions',
        canActivate: [AuthGuard],
        component: PositionsComponent
    },
    {
        path: `SiteSettings${routes.STYLING}`,
        canActivate: [AuthGuard],
        component: SiteSettingsStylingComponent
    },
    {
        path: `SiteSettings${routes.STYLING}${routes.STYLING_COLOURS}`,
        canActivate: [AuthGuard],
        component: StylingColoursComponent
    },
    {
        path: `SiteSettings${routes.STYLING}${routes.STYLING_COLOURS}${routes.EDITOR}`,
        canActivate: [AuthGuard],
        component: StylingColourEditorComponent
    },
    {
        path: `SiteSettings${routes.STYLING}${routes.STYLING_COLOURS}${routes.EDITOR}/:id`,
        canActivate: [AuthGuard],
        component: StylingColourEditorComponent
    },
    {
        path: `SiteSettings${routes.STYLING}${routes.COMPANY_LOGOS}`,
        canActivate: [AuthGuard],
        component: CompanyLogosComponent
    },
    {
        path: `SiteSettings${routes.STYLING}${routes.COMPANY_LOGOS}${routes.EDITOR}`,
        canActivate: [AuthGuard],
        component: CreateCompanyLogoComponent
    },
    {
        path: `SiteSettings${routes.STYLING}${routes.COMPANY_LOGOS}${routes.EDITOR}/:id`,
        canActivate: [AuthGuard],
        component: CompanyLogoEditorComponent
    },
    {
        path: `SiteSettings${routes.STYLING}${routes.COMPANY_LOGOS}/LogoEdit/:id`,
        canActivate: [AuthGuard],
        component: EditCompanyLogoFileComponent
    },
    {
        path: 'SiteSettings/Positions/Editor/:positionId',
        canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard],
        component: PositionEditorPageComponent
    },
    {
        path: 'SiteSettings/Positions/Editor',
        canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard],
        component: PositionEditorPageComponent
    },
    {
        path: 'SiteSettings/WorkLocations',
        canActivate: [AuthGuard],
        component: WorkLocationsListComponent
    },
    {
        path: 'SiteSettings/Forms',
        canActivate: [AuthGuard],
        component: FormsComponent
    },
    {
        path: 'SiteSettings/WorkRotations',
        canActivate: [AuthGuard],
        component: WorkRotationsComponent
    },
    {
        path: 'SiteSettings/WorkRotations/Editor',
        canActivate: [AuthGuard],
        component: WorkRotationEditorComponent
    },
    {
        path: 'SiteSettings/WorkRotations/Editor/:workRotationId',
        canActivate: [AuthGuard],
        component: WorkRotationEditorComponent
    },
    {
        path: `SiteSettings${routes.TIME_OFF}`,
        canActivate: [AuthGuard],
        component: TimeOffMenuComponent
    },
    {
        path: `TimeOff${routes.TIME_OFF}${routes.TIME_OFF_POLICIES_TYPES}`,
        canActivate: [AuthGuard],
        component: TimeOffPoliciesTypesComponent
    },
    {
        path: `TimeOff${routes.TIME_OFF}${routes.TIME_OFF_EMAILS}`,
        canActivate: [AuthGuard],
        component: TimeOffEmailsComponent
    },
    {
        path: `TimeOff${routes.BUY_SELL}`,
        canActivate: [AuthGuard],
        component: BuySellMenuComponent
    },
    {
        path: `TimeOff${routes.BUY_SELL}${routes.BUY_SELL_PLANS}`,
        canActivate: [AuthGuard],
        component: BuySellPlansComponent
    },
    {
        path: `TimeOff${routes.BUY_SELL}${routes.BUY_SELL_PLANS}${routes.EDITOR}/:buySellPlanId`,
        canActivate: [AuthGuard],
        component: BuySellPlanEditorComponent
    },
    {
        path: `TimeOff${routes.BUY_SELL}${routes.BUY_SELL_PLANS}${routes.EDITOR}`,
        canActivate: [AuthGuard],
        component: BuySellPlanEditorComponent
    },
    {
        path: `TimeOff${routes.BUY_SELL}${routes.APPROVALS}`,
        canActivate: [AuthGuard],
        component: BuySellApprovalsComponent
    },
    {
        path: 'TimeOff/Toil/Policies',
        canActivate: [AuthGuard],
        component: ToilPoliciesTypesComponent
    },
    {
        path: 'TimeOff/Toil/Emails',
        canActivate: [AuthGuard],
        component: ToilEmailsComponent
    },
    {
        path: 'TimeOff/StatutoryHolidays',
        canActivate: [AuthGuard],
        component: StatutoryHolidaysComponent
    },
    {
        path: 'SiteSettings/StatutoryHolidays/Editor',
        canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard],
        component: HolidayGroupsEditorComponent
    },
    {
        path: 'SiteSettings/StatutoryHolidays/Editor/:holidayGroupId',
        canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard],
        component: HolidayGroupsEditorComponent
    },
    {
        path: 'SiteSettings/Organization',
        canActivate: [AuthGuard],
        component: OrganizationStructureComponent
    },
    {
        path: 'SiteSettings/Organization/Editor',
        canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard],
        component: OrganizationEditorComponent
    },
    {
        path: 'SiteSettings/Organization/Editor/:organizationId',
        canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard],
        component: OrganizationEditorComponent
    },
    {
        path: 'SiteSettings/Configure',
        canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard],
        component: SiteSettingsConfigureComponent
    },
    {
        path: 'SiteSettings/Currency',
        canActivate: [AuthGuard],
        component: CurrenciesComponent
    },
    {
        path: 'SiteSettings/Translations',
        canActivate: [AuthGuard],
        component: TranslationsComponent
    },
    {
        path: 'SiteSettings/CostCenters',
        canActivate: [AuthGuard],
        component: CostCentersComponent
    },
    {
        path: 'SiteSettings/CountryConfig',
        canActivate: [AuthGuard],
        component: CountryConfigurationComponent
    },
    {
        path: 'SiteSettings/TableFieldEditor',
        canActivate: [AuthGuard],
        component: TableFieldEditorComponent
    },
    {
        path: 'SiteSettings/TableFieldEditor/:tableId/:fieldId',
        canActivate: [AuthGuard],
        component: TableFieldEditorComponent
    },
    {
        path: 'SiteSettings/GenerateSchedule',
        canActivate: [AuthGuard],
        component: RunJobFormComponent
    },
    {
        path: 'SiteSettings/BusinessRuleAutomation',
        canActivate: [AuthGuard],
        component: BusinessRuleAutomationComponent
    },
    {
        path: 'SiteSettings/BusinessRuleAutomation/Form/:id',
        canActivate: [AuthGuard],
        component: BusinessRuleAutomationFormComponent
    },
    {
        path: 'SiteSettings/BusinessRuleAutomation/Form',
        canActivate: [AuthGuard],
        component: BusinessRuleAutomationFormComponent
    },
    {
        path: 'SiteSettings/Integrations',
        canActivate: [AuthGuard],
        component: IntegrationsComponent
    },
    {
        path: 'SiteSettings/Integrations/Editor',
        canActivate: [AuthGuard],
        component: IntegrationEditorComponent
    },
    {
        path: 'SiteSettings/Integrations/Editor/:id',
        canActivate: [AuthGuard],
        component: IntegrationEditorComponent
    },
    {
        path: 'SiteSettings/QuickLinks',
        canActivate: [AuthGuard],
        component: QuickLinksComponent
    },
    {
        path: 'Security',
        canActivate: [AuthGuard],
        component: SecurityMenuComponent
    },
    {
        path: 'Security/Integration',
        canActivate: [AuthGuard],
        component: IntegrationConfigurationComponent
    },
    {
        path: 'Security/Api',
        canActivate: [AuthGuard],
        component: ApiSetupComponent
    },
    {
        path: 'Security/Setup',
        canActivate: [AuthGuard],
        component: SecuritySetupComponent
    },
    {
        path: 'Security/Roles',
        canActivate: [AuthGuard],
        component: SecurityRolesComponent
    },
    {
        path: 'Security/Roles/Editor',
        canActivate: [AuthGuard],
        component: SecurityRoleEditorComponent
    },
    {
        path: 'Security/Roles/Editor/:roleId',
        canActivate: [AuthGuard],
        component: SecurityRoleEditorComponent
    },
    {
        path: 'Letters/List',
        canActivate: [AuthGuard],
        component: CreatedLettersListComponent
    },
    {
        path: 'Letters/Editor',
        canActivate: [AuthGuard],
        component: CreateLetterComponent
    },
    {
        path: 'Letters/Editor/:letterId',
        canActivate: [AuthGuard],
        component: CreateLetterComponent
    },
    {
        path: 'Letters/Send',
        canActivate: [AuthGuard],
        component: SendLetterComponent
    },
    {
        path: 'Letters/Send/:letterId',
        canActivate: [AuthGuard],
        component: SendLetterComponent
    },
    {
        path: 'OrgChart',
        canActivate: [AuthGuard],
        component: OrgChartComponent
    },
    {
        path: 'Newsfeed',
        canActivate: [AuthGuard],
        component: NewsFeedComponent
    },
    {
        path: 'Inbox',
        canActivate: [AuthGuard],
        component: InboxComponent
    },
    {
        path: 'Homepage',
        canActivate: [AuthGuard],
        component: HomepageComponent
    },
    {
        path: 'Benefits',
        canActivate: [AuthGuard],
        component: BenefitsComponent
    },
    {
        path: 'Benefits/Coverages',
        canActivate: [AuthGuard],
        component: BenefitsCoveragesComponent
    },
    {
        path: 'Benefits/PlanTypes',
        canActivate: [AuthGuard],
        component: BenefitsPlanTypesComponent
    },
    {
        path: 'Benefits/PlanTypes/:planTypeId',
        canActivate: [AuthGuard],
        component: BenefitsPlanTypeDetailsComponent
    },
    {
        path: 'Benefits/Plans',
        canActivate: [AuthGuard],
        component: BenefitsPlansComponent
    },
    {
        path: 'Benefits/Plans/Editor',
        canActivate: [AuthGuard],
        component: BenefitsPlanEditorComponent
    },
    {
        path: 'Benefits/Plans/Editor/:planId',
        canActivate: [AuthGuard],
        component: BenefitsPlanEditorComponent
    },
    {
        path: 'Benefits/Groups',
        canActivate: [AuthGuard],
        component: BenefitsGroupsComponent
    },
    {
        path: 'Benefits/Groups/Editor',
        canActivate: [AuthGuard],
        component: BenefitGroupEditorComponent
    },
    {
        path: 'Benefits/Groups/Editor/:groupId',
        canActivate: [AuthGuard],
        component: BenefitGroupEditorComponent
    },
    {
        path: `${routes.PERFORMANCE_NO_SLASH}`,
        canActivate: [AuthGuard],
        component: PerformanceComponent
    },
    {
        path: `${routes.PERFORMANCE_NO_SLASH}${routes.GOAL_TYPES}`,
        canActivate: [AuthGuard],
        component: GoalTypesComponent
    },
    {
        path: `${routes.PERFORMANCE_NO_SLASH}${routes.GOAL_PLANS}`,
        canActivate: [AuthGuard],
        component: GoalPlansComponent
    },
    {
        path: `${routes.PERFORMANCE_NO_SLASH}${routes.GOAL_PLANS}/Editor/:goalPlanId`,
        canActivate: [AuthGuard],
        component: GoalPlanEditorComponent
    },
    {
        path: `${routes.PERFORMANCE_NO_SLASH}${routes.GOALS}`,
        canActivate: [AuthGuard],
        component: AllGoalsListComponent
    },
    {
        path: `${routes.PERFORMANCE_NO_SLASH}${routes.REVIEW_PLANS}`,
        canActivate: [AuthGuard],
        component: ReviewPlansComponent
    },
    {
        path: `${routes.PERFORMANCE_NO_SLASH}${routes.REVIEW_PLANS}/Editor/:reviewPlanId`,
        canActivate: [AuthGuard],
        component: ReviewPlanEditorComponent
    },
    {
        path: `${routes.PERFORMANCE_NO_SLASH}${routes.REVIEW_RATINGS}`,
        canActivate: [AuthGuard],
        component: ReviewRatingsComponent
    },
    {
        path: `${routes.PERFORMANCE_NO_SLASH}${routes.REVIEWS}`,
        canActivate: [AuthGuard],
        component: ReviewsComponent
    },
    {
        path: `${routes.PERFORMANCE_NO_SLASH}${routes.REVIEWS}/Editor/:reviewId`,
        canActivate: [AuthGuard],
        component: ReviewPageComponent
    },
    {
        path: `${routes.PERFORMANCE_NO_SLASH}${routes.MY_REVIEWS}`,
        canActivate: [AuthGuard],
        component: PerformanceSectionMyReviewsComponent
    },
    {
        path: `${routes.PERFORMANCE_NO_SLASH}${routes.GLOBAL_REVIEWS}`,
        canActivate: [AuthGuard],
        component: GlobalReviewsComponent
    },
    {
        path: `${routes.PERFORMANCE_NO_SLASH}${routes.GLOBAL_REVIEWS}/:reviewPlanId`,
        canActivate: [AuthGuard],
        component: GlobalReviewComponent
    },
    {
        path: 'Reports/Builder',
        canActivate: [AuthGuard],
        canDeactivate: [UnsavedGuard],
        component: ReportBuilderComponent
    },
    {
        path: 'Reports/Builder/Edit/:id',
        canActivate: [AuthGuard],
        canDeactivate: [UnsavedGuard],
        component: ReportBuilderComponent
    },
    {
        path: 'Reports/Builder/:type',
        canActivate: [AuthGuard],
        canDeactivate: [UnsavedGuard],
        component: ReportBuilderComponent
    },
    {
        path: 'Reports/Custom/Type/:type',
        canActivate: [AuthGuard],
        component: ReportsListComponent
    },
    {
        path: 'Reports/Custom/:id',
        canActivate: [AuthGuard],
        component: ReportRendererComponent
    },
    {
        path: 'Reports/Predefined/ReportAbsenceReport',
        canActivate: [AuthGuard],
        component: AbsenceReportComponent
    },
    {
        path: 'Reports/Predefined/ReportAbsenceFinanceReport',
        canActivate: [AuthGuard],
        component: AbsenceFinanceReportComponent
    },
    {
        path: 'Reports/Predefined/ReportOutstandingAbsenceReport',
        canActivate: [AuthGuard],
        component: OutstandingAbsenceReportComponent
    },
    {
        path: 'Reports/Predefined/ReportPendingTimeoffReport',
        canActivate: [AuthGuard],
        component: PendingTimeOffReportComponent
    },
    {
        path: 'Reports/Predefined/ReportGoalsReport',
        canActivate: [AuthGuard],
        component: GoalsReportComponent
    },
    {
        path: `${routes.LETTERS}`,
        canActivate: [AuthGuard],
        component: LettersComponent
    },
    {
        path: `${routes.LETTERS}/${routes.LETTERS_USER_SECTION}/:section`,
        canActivate: [AuthGuard],
        component: LettersUserSectionComponent
    },
    {
        path: `${routes.LETTERS}/${routes.LETTERS_ADMIN_SECTION}/:section`,
        canActivate: [AuthGuard],
        component: LettersAdminSectionComponent
    },
    {
        path: `${routes.LETTERS}/${routes.TEMPLATES}${routes.EDITOR}`,
        canActivate: [AuthGuard],
        component: LetterTemplateEditorComponent
    },
    {
        path: `${routes.LETTERS}/${routes.TEMPLATES}${routes.EDITOR}/:letterId`,
        canActivate: [AuthGuard],
        component: LetterTemplateEditorComponent
    },
    {
        path: `${routes.LETTERS}/${routes.LETTER_GENERATIONS}${routes.EDITOR}`,
        canActivate: [AuthGuard],
        component: LetterGenerationEditorComponent
    },
    {
        path: `${routes.LETTERS}/${routes.LETTER_GENERATIONS}${routes.EDITOR}/:letterGenerationId`,
        canActivate: [AuthGuard],
        component: LetterGenerationEditorComponent
    },
    {
        path: 'Reports/Predefined/ReportReviewStatusReport',
        canActivate: [AuthGuard],
        component: ReviewStatusReportComponent
    },
{
        path: `${routes.SITE_SETTINGS_NO_SLASH}${routes.ARTICLES}`,
        canActivate: [AuthGuard],
        component: ArticlesComponent
    },
    {
        path: `${routes.SITE_SETTINGS_NO_SLASH}${routes.ARTICLES}${routes.EDITOR}`,
        canActivate: [AuthGuard],
        component: ArticlesEditorComponent
    },
    {
        path: `${routes.SITE_SETTINGS_NO_SLASH}${routes.ARTICLES}${routes.EDITOR}/:articleId`,
        canActivate: [AuthGuard],
        component: ArticlesEditorComponent
    },
    {
        path: `${routes.IMPORTS}`,
        canActivate: [AuthGuard],
        component: ImportsComponent
    },
    {
        path: `${routes.IMPORTS}${routes.EDITOR}`,
        canActivate: [AuthGuard],
        component: ImportEditorComponent
    },
    {
        path: `${routes.IMPORTS}${routes.EDITOR}/:importId`,
        canActivate: [AuthGuard],
        component: ImportEditorComponent
    },
    {
        path: `${routes.IMPORTS}${routes.EDITOR}/:importId/:step`,
        canActivate: [AuthGuard],
        component: ImportEditorComponent
    },
    {
        path: `Documents`,
        canActivate: [AuthGuard],
        component: DocumentsManagerComponent
    },
];

@NgModule({
    imports: [RouterModule.forRoot(route_declarations)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
